import { useSelector } from "react-redux";

export function convertTo12HourFormat(hour) {
	if (hour < 0 || hour > 23) {
		return "Invalid input";
	}

	if (hour === 0) {
		return "12 am";
	} else if (hour === 12) {
		return "12 pm";
	} else if (hour < 12) {
		return hour + " am";
	} else {
		return hour - 12 + " pm";
	}
}

export const customLabelFormatter = (value, name) => {
	const timeValue = value.split(" ")[0];
	const timezone = value.split(" ")[1];
	return (
		<div>
			<p className="font-bold text-center">OCCUPANCY</p>
			<p>{`${timeValue}:00 ${timezone} - ${timeValue}:59 ${timezone}`}</p>
		</div>
	);
};
export const customLabelFormatterForDropoff = (value, name) => {
	const timeValue = value.split(" ")[0];
	const timezone = value.split(" ")[1];
	return (
		<div>
			<p className="font-bold text-center">PACKAGES</p>
			<p>{`${timeValue}:00 ${timezone} - ${timeValue}:59 ${timezone}`}</p>
		</div>
	);
};
export const CustomValueFormatter = (value, name) => {
	// const timeValue = value.split(" ")[0];
	// const timezone = value.split(" ")[1];
	const totalDoors = useSelector((state) => state.peakHoursReport.totalDoors);
	let output = ``;
	switch (name) {
		case "Small":
			output = `${value}% of ${totalDoors.small} doors`;
			break;
		case "Medium":
			output = `${value}% of ${totalDoors.medium} doors`;
			break;
		case "Large":
			output = `${value}% of ${totalDoors.large} doors`;
			break;
		case "XL":
			output = `${value}% of ${totalDoors.xl} doors`;
			break;
	}
	return output;
};
